export class Index {
  get(id: string) {
    console.log('Components from components package => ', id);
    return id;
  }
}
export * from './components';
export * from './modules/vuon-concert-2025';
